/**
 * Created by Admin on 2017/7/28.
 */
// 项目,人脉,跟进页码,以及筛选选项存储
export default {
  state: {
    node: 0
  },
  mutations: {},
  actions: {}
};



// WEBPACK FOOTER //
// ./src/store/modules/comPageAndSelect.js